import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useNetworkTracking } from '@xing-com/crate-network-tracking';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';
import { Section } from '@xing-com/layout-primitives';
import { LightMode } from '@xing-com/theme-mode-switcher';

import { Styled } from './get-discovered.styled';

export const GetDiscovered: FC = () => {
  const { trackNetworkNWTExtended } = useNetworkTracking();

  const loginUrl = useLoginAppUrl();

  const loginTracking = `?sc_o=contacts_network_get_discovered_register_click&signup_channel=minireg_network_hpreco`;
  const destParam = '&dest_url=' + encodeURIComponent('/network');
  const buttonUrl = loginUrl + loginTracking + destParam;

  const onClickCta = (): void => {
    trackNetworkNWTExtended({
      event: 'opened',
      element: 'register',
      moduleTitle: 'get_discovered',
    });
  };

  return (
    <Section data-qa="get-discovered-section">
      <LightMode>
        <Styled.ContainerCustom
          variant="expanded"
          data-qa="get-discovered-container"
        >
          <Styled.HeadlineText size="large" sizeConfined="xxlarge">
            <FormattedMessage id="NETWORK_LOGGED_OUT_GET_DISCOVERED_HEADLINE" />
          </Styled.HeadlineText>
          <Styled.DiscoverButton
            variant="primary"
            size="large"
            to={buttonUrl}
            onClick={onClickCta}
          >
            <Styled.DiscoverButtonContent>
              <Styled.Icon
                width={24}
                height={24}
                data-qa="get-discovered-button-icon"
              />
              <FormattedMessage id="NETWORK_LOGGED_OUT_GET_DISCOVERED_CTA" />
            </Styled.DiscoverButtonContent>
          </Styled.DiscoverButton>
        </Styled.ContainerCustom>
      </LightMode>
    </Section>
  );
};
